/* ag-form-source.js v2 (`agfs`, SPEC 136). Shopify prints each contact[Key] of
 * a storefront form as a labelled line in a <pre>. Every form posts Form,
 * Submitted From + Landing Page (origin, path, whitelisted query keys) and Click
 * Ids (one key=value a line); contact[body] is soft-wrapped at 72 columns
 * without touching the field's .value, on three paths sharing wrap(): a
 * window-capture `formdata` listener, fields(key, fd), and wrap() itself.
 * Laws: window CAPTURE listeners; every storage touch wrapped (Safari private
 * mode throws on access); never block or throw out of a submit; no CR emitted.
 * Record: theme-test/form-source/README.md.
 */
(function (w, d) {
  'use strict';

  var KEY = 'ag_landing';
  var ATTR = 'data-ag-form-key';
  var F_FORM = 'contact[Form]';
  var F_FROM = 'contact[Submitted From]';
  var F_LAND = 'contact[Landing Page]';
  var F_IDS = 'contact[Click Ids]';
  var F_BODY = 'contact[body]';
  var MAX_URL = 500;       /* ceiling: each posted URL, and the Click Ids field */
  var MAX_RAW = 2000;      /* the stored landing URL, so its click ids survive */
  var MAX_KEY = 120;
  var WIDTH = 72;
  var KEEP = ['variant', 'utm_source', 'utm_medium', 'utm_campaign',
              'utm_term', 'utm_content'];
  var IDS = ['gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid',
             'fbclid', 'msclkid', 'ttclid', 'dclid'];

  function clip(v, n) {
    v = (v === null || v === undefined) ? '' : String(v);
    return v.length > n ? v.slice(0, n) : v;
  }

  function href() {
    try { return String(w.location.href); } catch (e) { return ''; }
  }

  /* A newline at the last space at or before column n; newlines kept; a token
   * longer than n never split. Only spaces become newlines. */
  function wrap(text, n) {
    n = n > 0 ? n : WIDTH;
    var lines = String(text === null || text === undefined ? '' : text)
      .replace(/\r\n?/g, '\n').split('\n');
    var out = [], i, line, lead, cut;
    for (i = 0; i < lines.length; i++) {
      line = lines[i];
      while (line.length > n) {
        lead = line.length - line.replace(/^ +/, '').length;
        cut = line.lastIndexOf(' ', n);
        if (cut <= lead) { cut = line.indexOf(' ', lead); }
        if (cut <= lead) { break; }
        out.push(line.slice(0, cut));
        line = line.slice(cut + 1);
      }
      out.push(line);
    }
    return out.join('\n');
  }

  /* [origin + path, raw k=v pairs], fragment dropped. */
  function parts(u) {
    u = String(u || '');
    var h = u.indexOf('#');
    if (h >= 0) { u = u.slice(0, h); }
    var q = u.indexOf('?');
    return q < 0 ? [u, []] : [u.slice(0, q), u.slice(q + 1).split('&')];
  }

  function keyName(pair) {
    return pair.split('=')[0].toLowerCase();
  }

  /* Origin + path + whitelisted keys; `currency` goes with the rest. */
  function cleanUrl(u) {
    var p = parts(u), kept = [], i;
    for (i = 0; i < p[1].length; i++) {
      if (p[1][i] && KEEP.indexOf(keyName(p[1][i])) >= 0) { kept.push(p[1][i]); }
    }
    return clip(p[0] + (kept.length ? '?' + kept.join('&') : ''), MAX_URL);
  }

  /* Click ids, one key=value a line, first URL wins a key, whole ids only. */
  function clickIds(urls) {
    var seen = {}, out = [], len = 0, i, j, p, pair, eq, k, v, row;
    for (i = 0; i < urls.length; i++) {
      p = parts(urls[i])[1];
      for (j = 0; j < p.length; j++) {
        pair = p[j];
        eq = pair.indexOf('=');
        if (eq < 1) { continue; }
        k = pair.slice(0, eq).toLowerCase();
        v = pair.slice(eq + 1);
        if (IDS.indexOf(k) < 0 || seen[k] || !v || /\s/.test(v)) { continue; }
        row = k + '=' + v;
        if (len + row.length + (out.length ? 1 : 0) > MAX_URL) { continue; }
        len += row.length + (out.length ? 1 : 0);
        seen[k] = true;
        out.push(row);
      }
    }
    return out.join('\n');
  }

  function store() {
    try {
      var s = w.sessionStorage;
      return (s && typeof s.getItem === 'function') ? s : null;
    } catch (e) { return null; }
  }

  function readLanding() {
    var s = store();
    if (!s) { return null; }
    try {
      var raw = s.getItem(KEY);
      if (!raw) { return null; }
      var rec = JSON.parse(raw);
      return (rec && typeof rec.url === 'string' && rec.url) ? rec : null;
    } catch (e) { return null; }
  }

  /* The session's first pageview wins, kept raw so its click ids survive. */
  function captureLanding() {
    var have = readLanding();
    if (have) { return have; }
    var rec = {
      url: clip(href(), MAX_RAW),
      ref: clip((d && d.referrer) || '', MAX_URL),
      at: new Date().toISOString()
    };
    var s = store();
    if (s) {
      try { s.setItem(KEY, JSON.stringify(rec)); } catch (e) { /* quota */ }
    }
    return rec;
  }

  function keyOf(form) {
    if (!form || typeof form.getAttribute !== 'function') { return ''; }
    var k = form.getAttribute(ATTR);
    if (k) { return clip(k, MAX_KEY); }
    try {
      var el = form.querySelector('[' + ATTR + ']');
      if (el) { return clip(el.getAttribute(ATTR) || '', MAX_KEY); }
    } catch (e) { /* querySelector on a detached node */ }
    return '';
  }

  function bodyOf(fd) {
    try {
      var b = (fd && typeof fd.get === 'function') ? fd.get(F_BODY) : null;
      return typeof b === 'string' ? b : null;
    } catch (e) { return null; }
  }

  /* For the hand-built FormData paths; with fd, its body rides back wrapped. */
  function fields(key, fd) {
    var land = readLanding() || captureLanding();
    var here = href(), from = (land && land.url) || '';
    var out = {}, ids = clickIds([from, here]), body = bodyOf(fd);
    out[F_FORM] = clip(key || '', MAX_KEY);
    out[F_FROM] = cleanUrl(here);
    out[F_LAND] = cleanUrl(from);
    if (ids) { out[F_IDS] = ids; }
    if (body !== null) { out[F_BODY] = wrap(body); }
    return out;
  }

  /* Created when absent: Click Ids has no Liquid input. */
  function setInput(form, name, value) {
    var el = null;
    try {
      el = form.querySelector('input[name="' + name + '"]');
    } catch (e) { el = null; }
    if (!el) {
      if (!d || typeof d.createElement !== 'function') { return; }
      el = d.createElement('input');
      el.type = 'hidden';
      el.name = name;
      try { form.appendChild(el); } catch (e) { return; }
    }
    el.value = value;
  }

  function fill(form, key) {
    try {
      if (!form) { return false; }
      var k = key || keyOf(form);
      if (!k) { return false; }
      var f = fields(k);
      setInput(form, F_FORM, f[F_FORM]);
      setInput(form, F_FROM, f[F_FROM]);
      setInput(form, F_LAND, f[F_LAND]);
      if (f[F_IDS]) { setInput(form, F_IDS, f[F_IDS]); }
      return true;
    } catch (e) { return false; }
  }

  function onSubmit(ev) {
    try {
      var form = ev && ev.target;
      if (!form || form.nodeName !== 'FORM') { return; }
      fill(form);
    } catch (e) { /* never stop a submit */ }
  }

  /* Path a: the entry list, never the field. */
  function onFormData(ev) {
    try {
      var form = ev && ev.target, fd = ev && ev.formData;
      if (!form || form.nodeName !== 'FORM' || !fd || !keyOf(form)) { return; }
      var body = bodyOf(fd);
      if (body !== null) { fd.set(F_BODY, wrap(body)); }
    } catch (e) { /* law 3 */ }
  }

  /* Law 1: window, capture. */
  try {
    w.addEventListener('submit', onSubmit, true);
    w.addEventListener('formdata', onFormData, true);
  } catch (e) { /* ancient browser: the Liquid fallback values still ship */ }

  captureLanding();

  w.AGFormSource = {
    version: 2,
    fields: fields,
    fill: fill,
    key: keyOf,
    landing: readLanding,
    wrap: wrap,
    cleanUrl: cleanUrl,
    clickIds: clickIds,
    names: { form: F_FORM, from: F_FROM, landing: F_LAND, clickIds: F_IDS,
             body: F_BODY }
  };
}(window, document));
